export default abstract class PostRequest {
  abstract body(): Record<string, any>;
}
